<div class="summary-network-main">
    <div class="row row-cols-1 row-cols-xl-4 row-cols-md-3 g-4">

        <div class="col" *ngFor="let host of hosts">
            <div class="card bg-light text-dark h-100" (click)="GotonetworkOverviewPage(host.id)">
                <div class="card-body">
                    <h5 class="card-title">{{ host.reportedState.name }}</h5>
                    <div class="card-text d-flex justify-content-between align-items-center gap-3">
                        <div class="d-flex justify-content-between align-items-center gap-1">
                            <div class="udm-li connected"
                            ></div>
                            <div class="">{{ host.reportedState?.hardware?.shortname || "N/A" }}</div>
                        </div>
                        <!-- <button class="invited-btn">Invited</button> -->
                    </div>
                    <div class="pt-2">
                        <div class="ranger">

                        </div>
                        <div class="d-flex justify-content-between align-items-center gap-1">
                            <p class="mb-0 ranger-timer">02:40 AM</p>
                            <p class="mb-0 ranger-timer">02:40 AM</p>
                            <p class="mb-0 ranger-timer">Now</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center py-2">
                        <!-- <div class=" "><img src="assets/images/card-all-img/circle.svg" alt="" class="pe-2"></div> -->
                        <div>
                            <p class="mb-0">{{ host?.ispInfo?.name || "N/A" }}</p>
                        </div>
                    </div>
                    <div class="d-flex align-items-center repair-all-img pt-2">
                        <div class=" "><img src="assets/images/card-all-img/car-repair.svg" alt=""
                                class="setting-img pe-2"></div>
                        <div><img src="assets/images/card-all-img/car-repair.svg" alt="" class="ps-2">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col">
            <div class="card bg-light text-dark h-100">
                <div class="card-body">
                    <div class="w-100 h-100 d-flex justify-content-center align-items-center flex-column gap-2">
                        <img src="assets/images/card-all-img/circle-plus.svg" alt="">
                        <p class="mb-0">Create a New Site</p>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</div>
